<div class="bg-white rounded-lg py-3 mb-6">
  <div class="flex justify-between items-center mt-3 mb-6 px-6">
    <h1 class="font-semibold">Password Manager</h1>
    <!-- <button class="bg-[#D9D9D9] rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_1958_7961)">
                <path d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z" fill="#6C757D"/>
            </g>
            <defs>
                <clipPath id="clip0_1958_7961">
                <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
            </svg>
        </button> -->
  </div>
  <form [formGroup]="passwordManagerForm">
    <div class="flex border-t-2 pt-4 px-6 gap-8 flex-col">
      <div class="flex flex-col w-full">
        <div class="col-span-6 flex flex-col gap-2 relative">
          <h1 class="font-semibold">Old Password</h1>
          <input
            type="password"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Old Password"
            formControlName="old_password"
            [type]="showPassword ? 'password' : 'text'"
          />
          <img
            *ngIf="showPassword"
            (click)="showPassword = false"
            src="../../../assets/image/eye.svg"
            alt=""
            class="absolute top-10 right-4"
          />
          <img
            *ngIf="!showPassword"
            (click)="showPassword = true"
            src="../../../assets/image/closeeye.svg"
            alt=""
            class="absolute top-10 right-4"
          />
        </div>

        <div class="col-span-6 flex flex-col gap-2">
          <!-- <button
            [disabled]="
              passwordManagerForm.controls['old_password'].value == ''
            "
            (click)="resetPasswordForm = true"
            class="bg-[#0058e9] rounded-lg text-white text-[16px] px-4 py-2 w-fit flex-none"
            [ngStyle]="{
              'background-color':
                passwordManagerForm.controls['old_password'].value == ''
                  ? '#d1d1d1'
                  : '#0058e9'
            }"
          >
            Change Password
          </button> -->
        </div>
      </div>
      <div class="flex flex-col w-full gap-8">
        <div class="col-span-6 flex flex-col gap-2 relative">
          <!-- <h1 class="font-semibold">Update Your Password</h1> -->
          <h1 class="font-semibold">New Password</h1>
          <input
            type="password"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter New Password"
            formControlName="new_password"
            [type]="newPassword ? 'password' : 'text'"
          />
          <img
            *ngIf="newPassword"
            (click)="newPassword = false"
            src="../../../assets/image/eye.svg"
            alt=""
            class="absolute top-10 right-4"
          />
          <img
            *ngIf="!newPassword"
            (click)="newPassword = true"
            src="../../../assets/image/closeeye.svg"
            alt=""
            class="absolute top-10 right-4"
          />
        </div>

        <div class="col-span-6 flex flex-col gap-2 relative">
          <h1 class="font-semibold">Re-Enter Password</h1>
          <input
            type="password"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Re-Enter Password"
            formControlName="reEnterPassword"
            [type]="reEnterPassword ? 'password' : 'text'"
          />
          <img
            *ngIf="reEnterPassword"
            (click)="reEnterPassword = false"
            src="../../../assets/image/eye.svg"
            alt=""
            class="absolute top-10 right-4"
          />
          <img
            *ngIf="!reEnterPassword"
            (click)="reEnterPassword = true"
            src="../../../assets/image/closeeye.svg"
            alt=""
            class="absolute top-10 right-4"
          />
          <div
            style="color: red"
            *ngIf="passwordManagerForm?.get('reEnterPassword')?.errors?.['confirmPasswordValidator']"
          >
            Passwords do not match.
          </div>
        </div>
        <div class="flex w-full justify-end gap-2 pt-10 px-6">
          <button
            (click)="addPassword($event)"
            class="bg-[#0058e9] rounded-lg text-white text-[16px] px-4 py-2 w-fit flex-none"
          >
            Change Password
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
